/* eslint no-unused-vars: 1 */

(function() {
    'use strict';
    angular.module('shopAuth').service('cookieService', [ '$injector', function($injector) {

        var config = $injector.get('config');

        function setCookie(cname, cvalue, exminutes) {
            exminutes = exminutes || config.MNPCOOKIE.TTL;
            var d = new Date();
            d.setTime(d.getTime() + (exminutes * 60 * 1000));
            var expires = 'expires=' + d.toUTCString();

            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=' + config.MNPCOOKIE.PATH;
        }

        function getCookie(cname) {
            var name = cname + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (' ' === c.charAt(0)) {
                    c = c.substring(1);
                }
                if (0 === c.indexOf(name)) {
                    return c.substring(name.length, c.length);
                }
            }
            return null;
        }

        function killCookie(cname) {
            setCookie(cname, null, -1);
        }

        return {
            setCookie: setCookie,
            getCookie: getCookie,
            killCookie: killCookie
        };
    }
    ]);
}());
